import { COLLECTION_TAB_FOR_TYPE, SAME_DAY } from "../consts/collections";
import { ADD, REMOVE } from "../consts/map";
import { groupPostcodes, groupSectors } from "./lookUpTables";
import { Postcode } from "./postcode";

export const getCollectionEditAction = ({
  postcodeKey,
  routesByOuter,
  routeEditCode,
  collectionAreas,
  collectionSelectedTab,
  lookupTables,
}) => {
  const postcode = new Postcode(postcodeKey);
  const level = postcode.getLevel();

  const outer = postcode.toOuter();
  const sector = postcode.toSector();
  const sectors = groupSectors(lookupTables.SECTOR)[outer];
  const postcodes = sectors.reduce((acc, sector) => {
    acc[sector] = groupPostcodes(lookupTables.POSTCODE)[sector];
    return acc;
  }, {});

  const { sameDayRoute = null, plannedRoute = null } =
    collectionAreas[level]?.[postcodeKey] || {};

  const routeCode =
    COLLECTION_TAB_FOR_TYPE[collectionSelectedTab] === SAME_DAY
      ? sameDayRoute
      : plannedRoute;
  const impactRouteCodes = Array.from(
    new Set([
      routeEditCode,
      ...(routesByOuter[outer]?.[
        COLLECTION_TAB_FOR_TYPE[collectionSelectedTab]
      ] || []),
    ])
  );

  return {
    outer,
    sector,
    postcode: postcode.getPostcode(level),
    sectors,
    postcodes,
    level,
    collectionSelectedTab,
    type: routeCode === routeEditCode ? REMOVE : ADD,
    affectedRouteCode: routeCode,
    routeCode: routeEditCode,
    routeEditCode: routeEditCode,
    impactRouteCodes,
  };
};
